module.exports = __webpack_public_path__ + "img/live_contest.2928dd60.svg";